import { useTranslation } from "@sagot/i18n";
import { Icon } from "@sagot/ui";

/**
 * Decoration of the auth shell (mockup `.a-deco`): three colour tiles and a sample widget card, floating around the sign-in card.
 * Hidden under 900 px (auth.css). Purely visual: `aria-hidden`, never focusable, and the card is labelled "Sample" (D15, no invented claims).
 */
export function AuthAside() {
  const { t } = useTranslation();
  return (
    <div className="a-decos" aria-hidden="true">
      <div className="a-deco a-deco-sunset" />
      <div className="a-deco a-deco-sea" />
      <div className="a-deco a-deco-rice" />
      <div className="a-deco a-deco-widget">
        <div className="a-mini">
          <div className="a-mini-head">
            <b>{t("auth.aside.sampleLabel")}</b>
            <span className="a-mini-tag">{t("auth.aside.live")}</span>
          </div>
          <div className="a-mini-q">
            <span>{t("auth.aside.sampleQuestion")}</span>
          </div>
          <div className="a-mini-a">
            {t("auth.aside.sampleAnswerLead")} <b>{t("auth.aside.sampleAnswerAmount")}</b> {t("auth.aside.sampleAnswerTail")}
          </div>
          <span className="a-mini-src">
            <Icon name="file-text" />
            {t("auth.aside.sampleSource")}
          </span>
        </div>
      </div>
    </div>
  );
}
